import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { VersionEntity } from "../../entity";

export class GetAllVersionDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => VersionEntity)
  data!: VersionEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
